module.exports = function (blocking) {
  [process.stdout, process.stderr].forEach(function (stream) {
    if (stream._handle && stream.isTTY && typeof stream._handle.setBlocking === 'function') {
      stream._handle.setBlocking(blocking)
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/set-blocking/index.js
// module id = 97
// module chunks = 0